import clsx from 'clsx'
import { useState } from 'react'

export interface Props {
  src: string
  alt: string
  rounded?: boolean
}
export const ToolIcon = (props: Props) => {
  const { src, alt, rounded = true } = props
  const [hasError, setHasError] = useState(false)
  const randomAvatarBgColor = ['#22d3ee', '#2dd4bf', '#8393a5', '#c880b2', '#d67e84', '#f87171', '#7b90df', '#facc15']
  const getRandomAvatarBgColor = () => randomAvatarBgColor[Math.floor(Math.random() * randomAvatarBgColor.length)]

  const fallbackIcon = (
    <div
      className={clsx('rounded-full flex justify-center items-center text-white h-10 w-10')}
      style={{
        backgroundColor: getRandomAvatarBgColor(),
      }}
    >
      <span className="text-sm font-semibold"> {alt.charAt(0).toUpperCase()} </span>
    </div>
  )

  if (hasError) {
    return fallbackIcon
  }
  return (
    <img
      width={40}
      height={40}
      style={{
        borderRadius: rounded ? '100%' : 0,
        minHeight: '40px',
        minWidth: '40px',
        objectFit: 'contain',
      }}
      src={src}
      alt={alt}
      onError={() => setHasError(true)}
    />
  )
}
